module.exports = __webpack_public_path__ + "assets/img/33_1565_big.0ea4f9cf.jpg";